import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getCompanyId } from '@lognai/plugin-sdk';
import { createAiThread, listAiThreads, getAiThread, updateAiThread, type UpdateAiThreadPatch } from '../api/threads';
import { aiQueryKeys } from './query-keys';
import type { CreateThreadDto } from '@lognai/plugin-ai-core';

export const useAiThreads = () => {
  const hasCompany = !!getCompanyId();
  return useQuery({ queryKey: aiQueryKeys.threads(), queryFn: listAiThreads, enabled: hasCompany });
};

export const useAiThread = (id: string | null) =>
  useQuery({
    queryKey: id ? aiQueryKeys.thread(id) : [...aiQueryKeys.all, 'thread-null'],
    queryFn: () => getAiThread(id!),
    enabled: Boolean(id),
  });

export const useCreateAiThread = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: CreateThreadDto) => createAiThread(dto),
    onSuccess: () => qc.invalidateQueries({ queryKey: aiQueryKeys.threads() }),
  });
};

export const useUpdateAiThread = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, patch }: { id: string; patch: UpdateAiThreadPatch }) => updateAiThread(id, patch),
    onSuccess: (thread) => {
      qc.invalidateQueries({ queryKey: aiQueryKeys.threads() });
      qc.invalidateQueries({ queryKey: aiQueryKeys.thread(thread.id) });
    },
  });
};
